import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@material-ui/core';
// import { ResponsivePie } from '@nivo/pie';
import moment from 'moment';

import { useGlobal } from '../../../contexts/Global/context';
import { movimentacoesPendentes } from '../../../services';
import filterData from './utils/filterData';

import Loading from '../../../components/Loading';
import CenteredMetric from './components/CenteredMetric';
import Header from './components/Header';
import Legends from './components/Legends';

import * as S from './styles';
import { Card } from '../styles';

export default function PendingTransactions() {
    const [graphData, setGraphData] = useState([]);
    const [periodFilter, setPeriodFilter] = useState({
        id: 'periodFilter',
        label: '',
        required: false,
        options: [
            { codigo: 7, nome: 'Últimos 7 dias' },
            { codigo: 15, nome: 'Últimos 15 dias' },
        ],
        value: 7,
    });

    const [loading, setLoading] = useState(true);

    const { dataActiveContract, contrastTheme } = useGlobal();

    const history = useHistory();

    function handleClick(data) {
        if (dataActiveContract.isSpecificContract) {
            return;
        }

        const startDate = moment().subtract(periodFilter.value, 'days').toISOString();

        const currentDate = moment().toISOString();

        const graphFilter = {
            statusValue: data.data?.statusValue || data.statusValue,
            dateRange: [startDate, currentDate],
        };

        history.push({
            pathname: '/movimentacao_cadastral/movimentacoes_pendentes',
            graphFilter,
        });
    }

    useEffect(() => {
        async function getData() {
            setLoading(true);

            const startDate = moment().subtract(periodFilter.value, 'days');
            const currentDate = moment();

            const movements = dataActiveContract.isSpecificContract
                ? []
                : await movimentacoesPendentes({
                      numContrato: dataActiveContract.numero,
                      dtInicioPeriodo: startDate,
                      dtFimPeriodo: currentDate,
                      offset: 0,
                      limit: 1000,
                  });

            const filteredData = await filterData(movements, 'Movimentações pendentes');

            setGraphData(filteredData);

            setLoading(false);
        }

        getData();
    }, [periodFilter, dataActiveContract]);

    return (
        <Card>
            {loading ? (
                <Box height={200} display="flex" justifyContent="space-evenly" alignItems="center">
                    <Loading />
                </Box>
            ) : (
                <>
                    <Header
                        title="Movimentações pendentes"
                        periodFilter={periodFilter}
                        setPeriodFilter={setPeriodFilter}
                    />

                    <Box display="flex" justifyContent="space-evenly" flexWrap="wrap" sx={{ gap: 74 }}>
                        <Box width={200} height={200}>
                            <S.CustomResponsivePie
                                data={graphData}
                                layers={['arcs', CenteredMetric]}
                                width={200}
                                height={200}
                                margin={{ left: 0 }}
                                fit={false}
                                innerRadius={0.6}
                                padAngle={0.5}
                                colors={{ datum: 'data.color' }}
                                onClick={handleClick}
                                isInteractive={false}
                                borderWidth="1px"
                                borderColor={contrastTheme ? '#FFF333' : 'transparent'}
                            />
                        </Box>

                        <Legends data={graphData} onClick={handleClick} />
                    </Box>
                </>
            )}
        </Card>
    );
}
